import React from 'react';
import styled from 'styled-components';

import Star from './Star';
import type { Rating } from '@/types';

interface MyRatingProps {
  rating: Rating;
  resetStarRating: () => void;
}

const Container = styled.div`
  display: flex;
  align-items: center;
  flex-grow: 0;
`;

const StarsWrapper = styled.div`
  display: flex;
  width: 90px;
`;

const StarContainer = styled.div`
  width: 20%;
  padding: 0 2%;
`;

const ChangeButton = styled.button`
  border: none;
  background: none;
  color: #6d89aa;
  padding: 4px 8px;
  cursor: pointer;
  font-size: 12px;

  &:hover {
    text-decoration: underline;
  }
`;

const MyRating: React.FC<MyRatingProps> = ({ rating, resetStarRating }) => {
  return (
    <Container>
      <StarsWrapper>
        {[1, 2, 3, 4, 5].map((num) => (
          <StarContainer key={num}>
            <Star
              isActive={rating.stars_count >= num}
              highlightOnMobile={false}
            />
          </StarContainer>
        ))}
      </StarsWrapper>

      <ChangeButton onClick={resetStarRating}>Change my rating</ChangeButton>
    </Container>
  );
};

export default MyRating;
